export default __webpack_public_path__ + "media/images/icons/atention-9e2a1973f4d25ad0733537ca5077a635.svg";